import { useCallback, useState } from "react";

export const useHomeDialogs = () => {
  const [quote, setQuote] = useState({ open: false, service: null, prefill: null });
  const [tip, setTip] = useState({ open: false, source: "site" });
  const openTip = useCallback((source = "site") => setTip({ open: true, source }), []);
  const closeTip = useCallback(() => setTip((current) => ({ ...current, open: false })), []);
  const openQuote = useCallback((service = null, prefill = null) => setQuote({ open: true, service, prefill }), []);
  const closeQuote = useCallback(() => setQuote((current) => ({ ...current, open: false })), []);
  return { quote, tip, openTip, closeTip, openQuote, closeQuote };
};